<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="welcome-page">
        <b-container class="input-group-responsive text-center pt-3 position-relative">
            <b-btn variant="light" style="position: absolute; right: 15px; top: 15px;" @click="changeLanguage"><span v-tr>Français|English</span></b-btn>
            <b-img class="mb-2" center width="64" :src="require('../assets/img/branding/' + logoName)" alt="Eye-In Wireless"></b-img>

            <div class="card-container">

                <h5 class="" v-tr>Select your WiFi Plan|Choisissez votre forfait WiFi</h5>
                <b-row class="text-center">
                    <b-col md="4" class="mx-auto" v-for="wifiPlan in wifiPlans" :key="wifiPlan.name">
                        <b-card class="wifi-plan">
                            <b-card-header>
                                <div class="icon" :style="{ background: wifiPlan.color }">
                                    <i class="fas " :class="wifiPlan.icon"></i>
                                </div>
                                <h5 class="name" v-tr>{{ wifiPlan.name }}</h5>
                                <div class="price">{{wifiPlan.price|price}}</div>
                            </b-card-header>
                            <div class="description py-2">
                                <div>
                                    <i class="fas fa-check mx-3 f-9"></i>
                                    <span v-tr>Secured WiFi Connection|Connexion WiFi sécurisée</span>
                                </div>
                                <div>
                                    <i class="fas fa-check mx-3 f-9"></i>
                                    <span v-tr>WiFi Access with |Accès WiFi avec </span>
                                    {{ wifiPlan.speed|tr }}
                                </div>
                            </div>
                            <div class="action text-center mt-1">
                                <b-btn @click="selectWifiPlan(wifiPlan)" size="sm" variant="primary" class="ml-2">
                                    <span v-tr>Select Plan|Choisir le plan</span>
                                    <i class="fas fa-arrow-right ml-1"></i>
                                </b-btn>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>

                <div class="py-4 text-center">
                    <b-img width="200" center :src="require('../assets/img/paypal-payment.png')"></b-img>
                </div>

                <div class="clearfix"></div>
                <div v-if="isFromWifi" class="text-center mt-4 pb-4">
                    <b-btn @click="window.history.back()" variant="outline-primary">
                        <i class="fas fa-chevron-left mr-1"></i>
                        <span v-tr>Back to the login page|Retour à la page de connexion</span>
                    </b-btn>
                </div>
            </div>
            <b-modal v-if="wifiPlanSelected" v-model="showPaymentModal" :title="'Payment method|Mode de paiement'|tr" no-close-on-esc scrollable
                     no-close-on-backdrop ok-only :ok-title="'Cancel|Annuler'|tr">
                <b-img center width="100" height="100" :src="require('../assets/img/purse.png')"/>
                <h3 class="text-center my-3">Total {{ wifiPlanSelected.price|price }}</h3>
                <e-payment-input-web-only no-apple-pay no-square v-if="wifiPlanSelected" :options="paymentOptions"></e-payment-input-web-only>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
    import EPaymentInputWebOnly from "../components/e-payment-input-web-only.vue";

    export default {
        name: `register`,
        components: {EPaymentInputWebOnly},
        data() {
            return {
                wifiPlanSelected: null,
                showPaymentModal: null,
                paymentOptions: null,
                wifiPlans: [
                    {
                        name: `Starter Pack|Pack de démarrage`,
                        price: 2.95,
                        speed: `3MB/s`,
                        color: `#15cb89`,
                        icon: `fa-wifi`
                    },
                    {
                        name: `Advanced Pack|Pack avancé`,
                        price: 4.95,
                        speed: `6MB/s`,
                        color: `#fd875d`,
                        icon: `fa-wifi`
                    },
                    {
                        name: `Premium Pack|Pack premium`,
                        price: 7.95,
                        speed: `No Speed Limit|aucune limite`,
                        color: `#7a5dfd`,
                        icon: `fa-wifi`
                    }
                ]
            }
        },
        methods: {
            changeLanguage() {
                this.$store.commit(`changeLanguage`);
                this.$router.go();
            },
            selectWifiPlan(wifiPlan) {
                this.wifiPlanSelected = wifiPlan;

                this.paymentOptions = {
                    amount: this.wifiPlanSelected.price,
                    currency: `CAD`,
                    // first_name: this.user.first_name,
                    // last_name: this.user.last_name,
                    // phone: this.user.phone_number,
                    // email: this.user.email,
                    // address: this.user.address,
                    // address_complement: this.user.address_complement,
                    // postal_code: this.user.postal_code,
                    // city: this.user.city,
                    // state: this.user.state,
                    country: `CA`// Required field for Apple Pay
                };

                this.showPaymentModal = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/style/welcome-page";
    @import "../assets/style/bootstrap-theme.scss";

    .welcome-header {
        small {
            font-size: 12pt;
            font-weight: 700;
            letter-spacing: 1px;
        }

        h4 {
            font-size: 40pt;
            font-weight: 700;
            margin-bottom: 50px;
        }
    }

    .welcome-page {
        .card.wifi-plan {
            max-width: calc(100% - 30px);
            background: #fff;
            box-shadow: 2px 15px rgba(0, 0, 0, 0.1);
            margin-bottom: 0 !important;
            text-align: left;

            .card-header {
                background: none;
                border-bottom: 2px solid #ddd;
                padding: 0 0 10px;

                h5 {
                    margin-bottom: 3px;
                }

                .price {
                    font-weight: 500;
                    font-size: 11pt;
                }

                .icon {
                    float: left;
                    text-align: center;
                    line-height: 48px;
                    width: 48px;
                    height: 48px;
                    border-radius: 8px;
                    margin-right: 15px;
                    color: white;

                    .fas {

                    }
                }
            }
        }
    }

    @media(max-width: 576px) {
        .title {
            font-size: 1.5em !important;
        }
    }
</style>
